import { render } from "./PayDetail.vue?vue&type=template&id=4b50e98a&scoped=true&ts=true"
import script from "./PayDetail.vue?vue&type=script&lang=ts"
export * from "./PayDetail.vue?vue&type=script&lang=ts"

import "./PayDetail.vue?vue&type=style&index=0&id=4b50e98a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b50e98a"]])

export default __exports__